import axios from 'axios';
import OrderRepository from '../repositories/signalR'; // signalr is a legacy name, will be renamed to orderrepo in the future. todo :-)
import { EventBus } from '../repositories/Eventbus';
import configRepository from '../repositories/ConfigRepository';
import { BatchStatus } from '../repositories/Constants';


var BonchefRepository = function () {

    var _config = configRepository.getConfig();
           
    function _callApi(action, batchIds) {

        var url = _config.endPointUrl + 'api/Terminal/' + action;

        // Creating a promise
        var promise = new Promise(function (resolve, reject) {
            // axios, for a full list of options see: https://github.com/axios/axios
            axios({
                method: 'POST',
                url: url,
                data: 
                    batchIds
                ,
                withCredentials: true
            }).then(function (response) {
                if (response.data.success) {
                    resolve(true);
                }
                else
                    reject(response.data.messages);
            }).catch(function (err) {
                window.console.log('#RescheduleRepository: Error calling ' + action + ' :' + err);
                reject(err);
            });
        });

        return promise;
    }

    function pushBonChefInstructionToQueue(instruction_batches, instruction_window_start) {

        // store instruction
        if (instruction_batches.length) {

            // Set isConfirmed for Bonchef instruction when bonchef===true OR when end time of batch is in the past.
            var isConfirmed = instruction_batches.every(b => b.bonchef === true || (b.endTime < Date.now() && b.status > BatchStatus.Prepared));

            var bonchef_instruction = {
                'batches': instruction_batches,
                'createdAtUtc': instruction_window_start,
                'confirmedAtUtc': isConfirmed ? Date.now() : null, // get from storage?
                'showPriorBonchef' : false
            };

            //_data.que = _data.que.filter(q => q.createdAtUtc !== instruction_window_start);

            _data.que.push(bonchef_instruction);

        }
    }

    var _gatherBatches = function() {
        
        let allBatches = [];
        let instruction_batches = [];
        let instruction_window_start = new Date(0); // set to minDate

        // clear queue
        _data.que.splice(0, _data.que.length);

        // Get selected unit groups from Config-repo
        const _collectUnitGroupIds = configRepository.getConfig().collectUnitGroupIds;

        // filter selected unit groups from Order-repo
        const visibleUnitGroups = OrderRepository.units.filter(u => _collectUnitGroupIds.includes(u.id));

        // Collect batches from selected unit groups 
        visibleUnitGroups.forEach( function (unitGroup) {
            // Concatenate the batches from each visible unit into allBatches
            unitGroup.units.forEach(function (unit) {
                allBatches = allBatches.concat(unit.batches);
            });
        });

        // Sort the merged batches by startingTime
        allBatches.sort(function (a, b) {
            // Assuming startingTime is a Date property in each batch
            return a.startTime - b.startTime;
        });

        allBatches.forEach(function (batch) {

            const batchStartDiff = batch.startTime - instruction_window_start;

            // Check bonchefGroupBatchWindow setting, set 10 seconds when undefined..
            const _order = batch.orders.find(order => order.bonchefGroupBatchWindow !== undefined);
            const instruction_window_size = (_order ? _order.bonchefGroupBatchWindow : 10) * 1000; //convert to milliseconds

            if (batchStartDiff > instruction_window_size) {            
                pushBonChefInstructionToQueue(instruction_batches, instruction_window_start);
                // new instruction! 
                instruction_batches = []; // reset
                instruction_window_start = batch.startTime;
            }

            // add batch to current instruction
            batch.bonchefRequested = true;
            instruction_batches.push(batch);

        });
        
        pushBonChefInstructionToQueue(instruction_batches, instruction_window_start);

        _data.bonchefInstructionsWaiting = BonchefInstructionsWaiting();

        return true;

    }

    var _doBonChef = function () {

        // get first bonchef instruction (first in, first out)
        var bonchef = _data.que.find(q => q.confirmedAtUtc === null);

        // set bonchef=true for each batch in this bonchef-instruction
        bonchef.batches.forEach(a => a.bonchef = true);

        _callApi('bonchef', bonchef.batches.map(a => a.id)).then(function () {
            //_data.que.shift();
            bonchef.confirmedAtUtc = Date.now();
        });

    }

    var _hidePriorBonChef = function () {

        _data.que.find(q => q.showPriorBonchef).showPriorBonchef = false;

    }

    const BonchefInstructionsWaiting = function () {
   
        const queWaiting = _data.que.filter(q =>
            q.batches.some(b => b.status >= BatchStatus.Preparing) &&
            q.confirmedAtUtc === null
        );

        // close all prior bonchef instructions when new bonchef instructions are present
        if (queWaiting.length) {
            _data.que.forEach(item => {
                item.showPriorBonchef = false;
            });
        }

        _data.openBonchefInstructions = queWaiting;

        return queWaiting.length;
    }


    var _toggleBonChefInstruction = function(order) {
       
        // close all prior bonchef instructions when new bonchef instructions are present
        _data.que.forEach(item => {
            item.showPriorBonchef = false;
        });

        // can't show prior instructions when there are open BonChef instructions
        if (_data.bonchefInstructionsWaiting === 0) {
            // filter prior bonchef instructions
            const priorBonchefs = _data.que.filter(q => q.confirmedAtUtc != null);
            // loop trough allbatches in order clicked
            for (const batch of order.batches) {
                let _bonchef = priorBonchefs.find((q) => q.batches.find((b) => b.id === batch.id));
                if (_bonchef) {
                    _bonchef.showPriorBonchef = true;
                }
            }
        }

    }

    /* ------------------------------------
    | E V E N T S 
    --------------------------------------*/
    let timeout = null;
    EventBus.$on('batches-changed', function () {
        // small delay, wait for all batch changed event to raise.
        if (timeout) {
            window.clearTimeout(timeout);
        }
        timeout = window.setTimeout(function () {
            _gatherBatches();
        }, 100);

    });

    EventBus.$on('units-loaded', _gatherBatches); 

    EventBus.$on('scroll-x-to', function (order) {
        // show all BonChef instructions associated to this order
        _toggleBonChefInstruction(order);
    });

    var _data = {

        // que of bonchef batches, contains a 2 dimensinal array
        que: [],
        bonchefInstructionsWaiting: 0,
        openBonchefInstructions: [],

        init: function () {

        },

        doBonChef: function () {
            return _doBonChef();
        },

        hidePriorBonChef: function () {
            return _hidePriorBonChef();
        }

    };

    _data.init();

    return _data;
}()

export { BonchefRepository as default };